import { render, staticRenderFns } from "./MachineCard.vue?vue&type=template&id=2c75dd42"
import script from "./MachineCard.vue?vue&type=script&lang=js"
export * from "./MachineCard.vue?vue&type=script&lang=js"
import style0 from "./MachineCard.vue?vue&type=style&index=0&id=2c75dd42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports